var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractiveVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 175C58.7776 175 25.2002 141.423 25.2002 100C25.2002 58.5774 58.7776 25 100.2 25C141.623 25 175.2 58.5774 175.2 100C175.2 141.423 141.623 175 100.2 175Z",
    fill: "url(#paint0_linear_26801_678)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.151 42.1231C118.649 39.2923 83.1475 39.2923 47.6458 42.1231C42.345 42.5457 38.1103 46.7384 37.5372 52.0858C34.4212 81.154 34.4212 110.222 37.5372 139.291C38.1106 144.638 42.3453 148.831 47.6458 149.253C83.1475 152.084 118.649 152.084 154.151 149.253C159.452 148.831 163.686 144.638 164.26 139.291C167.376 110.223 167.376 81.1543 164.26 52.0858C163.686 46.7384 159.452 42.5457 154.151 42.1231Z",
    fill: "url(#paint1_linear_26801_678)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.719 68.9797L165.666 68.9743C122.488 65.123 79.3096 65.123 36.1312 68.9743L36.0784 68.9823C36.4459 63.3499 36.9322 57.7203 37.5378 52.0879C38.1114 46.7392 42.3467 42.5457 47.6449 42.1231C83.1483 39.2936 118.649 39.2936 154.153 42.1231C159.451 42.5457 163.686 46.7392 164.26 52.0881C164.865 57.7177 165.352 63.3501 165.719 68.9797Z",
    fill: "url(#paint2_linear_26801_678)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9301 60.4755C55.3551 60.4755 58.1316 57.6668 58.1316 54.2021C58.1316 50.7374 55.3551 47.9286 51.9301 47.9286C48.505 47.9286 45.7285 50.7374 45.7285 54.2021C45.7285 57.6668 48.505 60.4755 51.9301 60.4755Z",
    fill: "#F87171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1388 60.4755C92.5638 60.4755 95.3404 57.6668 95.3404 54.2021C95.3404 50.7374 92.5638 47.9286 89.1388 47.9286C85.7138 47.9286 82.9373 50.7374 82.9373 54.2021C82.9373 57.6668 85.7138 60.4755 89.1388 60.4755Z",
    fill: "#A7F3D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5341 60.4755C73.9591 60.4755 76.7356 57.6668 76.7356 54.2021C76.7356 50.7374 73.9591 47.9286 70.5341 47.9286C67.1091 47.9286 64.3325 50.7374 64.3325 54.2021C64.3325 57.6668 67.1091 60.4755 70.5341 60.4755Z",
    fill: "#FBE7A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.199 131.75V134.627C148.199 136.975 146.317 138.88 143.993 138.88H57.8049C55.481 138.88 53.5986 136.975 53.5986 134.627V131.75C53.5986 129.401 55.481 127.497 57.8049 127.497H143.992C146.317 127.497 148.199 129.401 148.199 131.75Z",
    fill: "#D4D9E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0636 127.497V138.88H57.8049C55.481 138.88 53.5986 136.975 53.5986 134.627V131.75C53.5986 129.401 55.481 127.497 57.8049 127.497H79.0636Z",
    fill: "url(#paint3_linear_26801_678)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1528 127.497H82.2043V138.881H76.1528V127.497Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.455 93.367L97.896 83.1117C93.4668 80.5248 87.9302 83.7584 87.9302 88.9321V109.442C87.9302 114.616 93.4668 117.85 97.896 115.263L115.455 105.008C119.884 102.421 119.884 95.9538 115.455 93.367Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.788 133.818C121.788 138.901 125.865 143.013 130.885 143.013C135.905 143.013 139.983 138.901 139.983 133.818C139.983 128.735 135.905 124.624 130.885 124.624C125.865 124.624 121.788 128.735 121.788 133.818Z",
    stroke: "url(#paint4_linear_26801_678)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.885 140.53C134.555 140.53 137.53 137.525 137.53 133.818C137.53 130.111 134.555 127.107 130.885 127.107C127.215 127.107 124.24 130.111 124.24 133.818C124.24 137.525 127.215 140.53 130.885 140.53Z",
    fill: "url(#paint5_linear_26801_678)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.119 127.107C134.66 127.107 137.53 130.111 137.53 133.818C137.53 137.525 134.66 140.53 131.119 140.53C130.789 140.53 130.464 140.503 130.147 140.453C133.227 139.963 135.587 137.179 135.587 133.818C135.587 130.457 133.227 127.673 130.147 127.183C130.464 127.133 130.789 127.107 131.119 127.107Z",
    fill: "url(#paint6_linear_26801_678)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.455 153.69L129.137 139.12C128.175 137.435 128.751 135.262 130.417 134.289C132.083 133.316 134.233 133.9 135.194 135.584L142.022 147.543C141.52 145.964 142.157 144.179 143.632 143.318C145.305 142.341 147.464 142.903 148.462 144.577C148.382 143.369 148.968 142.16 150.069 141.517C151.609 140.618 153.596 141.156 154.484 142.713L154.747 143.172C154.861 142.205 155.408 141.301 156.301 140.779C157.806 139.9 159.746 140.426 160.615 141.948C164.608 148.942 165.193 149.966 167.939 154.776C168.689 156.091 169.041 157.389 169.058 158.907C169.064 159.395 169.197 159.882 169.456 160.336L171.05 163.128C171.361 163.673 171.175 164.374 170.636 164.689L153.238 174.847C152.699 175.162 152.006 174.974 151.694 174.429L150.101 171.637C149.572 170.712 148.667 170.181 147.61 170.176L143.502 170.16C141.179 170.151 139.03 169.32 137.695 167.398L134.159 162.305C132.42 159.258 133.398 156.059 136.409 154.301L137.455 153.69Z",
    fill: "#F8FAFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.189 141.878C155.455 141.436 155.83 141.054 156.301 140.779C157.806 139.9 159.746 140.426 160.615 141.948C164.608 148.942 165.193 149.966 167.939 154.776C168.69 156.091 169.042 157.389 169.058 158.907C169.064 159.395 169.197 159.882 169.456 160.336L171.05 163.128C171.361 163.673 171.176 164.374 170.637 164.689L168.027 166.213C168.566 165.898 168.752 165.197 168.441 164.652L166.847 161.86C166.588 161.406 166.455 160.918 166.449 160.431C166.432 158.913 166.08 157.615 165.33 156.3C162.583 151.489 161.999 150.466 158.006 143.471C157.409 142.427 156.308 141.852 155.189 141.878ZM148.462 144.577C147.464 142.903 145.304 142.341 143.631 143.318C143.166 143.59 142.783 143.954 142.494 144.374C143.806 144.263 145.132 144.892 145.852 146.1L146.983 148.081C147.399 148.81 148.321 149.06 149.041 148.639C149.762 148.218 150.009 147.286 149.593 146.558C149.216 145.897 148.839 145.237 148.462 144.577ZM148.951 142.607C150.111 142.565 151.258 143.155 151.875 144.237C152.141 144.702 152.407 145.168 152.673 145.634C153.089 146.363 154.01 146.612 154.731 146.192C155.452 145.771 155.698 144.839 155.282 144.111C155.016 143.645 154.75 143.179 154.484 142.713C153.595 141.156 151.609 140.618 150.068 141.517C149.598 141.791 149.222 142.17 148.951 142.607ZM129.284 135.352C129.57 134.928 129.95 134.561 130.417 134.289C132.083 133.316 134.233 133.9 135.194 135.584C137.967 140.44 140.74 145.297 143.512 150.154C143.928 150.883 143.682 151.814 142.961 152.235C142.24 152.656 141.319 152.406 140.903 151.677C138.13 146.821 135.357 141.964 132.585 137.107C131.893 135.895 130.584 135.253 129.284 135.352ZM134.957 155.409C135.37 154.998 135.855 154.625 136.409 154.301L137.455 153.691L141.028 159.949C141.444 160.678 141.197 161.61 140.477 162.031C139.757 162.451 138.835 162.202 138.419 161.473L134.957 155.409Z",
    fill: "#F8FAFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.1 171.637L169.456 160.336L171.05 163.128C171.361 163.673 171.175 164.374 170.636 164.689L153.238 174.847C152.699 175.162 152.005 174.974 151.694 174.429L150.1 171.637Z",
    fill: "url(#paint7_linear_26801_678)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.847 161.86L169.456 160.336L171.05 163.128L171.064 163.154L171.078 163.179L171.09 163.206L171.102 163.232L171.114 163.258L171.124 163.285L171.134 163.312C171.138 163.321 171.141 163.33 171.144 163.339L171.152 163.365L171.16 163.392L171.167 163.42L171.174 163.447L171.18 163.474L171.185 163.502L171.189 163.529C171.19 163.539 171.191 163.548 171.192 163.557C171.195 163.575 171.196 163.594 171.198 163.612L171.2 163.64L171.201 163.667L171.201 163.695C171.201 163.713 171.2 163.732 171.2 163.75L171.198 163.777L171.196 163.805L171.193 163.832L171.189 163.859C171.187 163.877 171.184 163.895 171.18 163.913C171.177 163.931 171.173 163.949 171.169 163.967L171.162 163.994L171.155 164.02C171.15 164.037 171.144 164.055 171.138 164.072C171.132 164.089 171.126 164.106 171.119 164.124L171.109 164.149L171.098 164.174L171.086 164.199L171.074 164.223C171.066 164.24 171.057 164.256 171.048 164.272L171.034 164.295L171.02 164.319L171.005 164.342C170.994 164.357 170.984 164.372 170.973 164.387L170.956 164.409L170.938 164.431L170.92 164.452L170.902 164.473L170.883 164.493L170.863 164.513L170.843 164.533L170.822 164.552L170.801 164.571L170.779 164.589L170.757 164.606L170.734 164.623L170.711 164.64L170.687 164.656L170.663 164.672L170.638 164.687L168.028 166.21C168.567 165.896 168.753 165.194 168.442 164.65L166.847 161.86Z",
    fill: "#D1D1D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_678",
    x1: 25.2002,
    y1: 36.7188,
    x2: 168.169,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_678",
    x1: 100.898,
    y1: 40,
    x2: 100.898,
    y2: 151.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_678",
    x1: 100.899,
    y1: 40.001,
    x2: 100.899,
    y2: 68.9823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_678",
    x1: 56.3839,
    y1: 127.497,
    x2: 70.2692,
    y2: 146.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_678",
    x1: 138.384,
    y1: 124.124,
    x2: 116.062,
    y2: 137.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_678",
    x1: 125.694,
    y1: 127.107,
    x2: 141.148,
    y2: 136.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_678",
    x1: 130.955,
    y1: 127.107,
    x2: 141.563,
    y2: 130.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_678",
    x1: 151.155,
    y1: 175.567,
    x2: 171.235,
    y2: 174.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveVideo);
export default __webpack_public_path__ + "static/media/Interactive-Video.a5a364e876b4e1a184e24f345d9aa977.svg";
export { ForwardRef as ReactComponent };